<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">زبان خارجی مورد نیاز</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-2">
          <label class="form-label fw-bold">نام زبان</label>
          <input
              type="text"
              class="form-control"
              placeholder="نام زبان را وارد کنید"
              v-model="newLanguage.name"
          />
        </div>
        <div class="col-md-2" v-for="(skill, index) in languageSkills" :key="index">
          <label class="form-label fw-bold">{{ skill }}</label>
          <select class="form-select" v-model="newLanguage[index]">
            <option value="" disabled>تعیین سطح</option>
            <option :value="levelValue" v-for="(levelValue, levelIndex) in levels" :key="levelIndex">
              {{ levelValue }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addLanguage"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Languages Table -->
      <GeneralTable
          :headers="['نام زبان', languageSkills.read, languageSkills.write, languageSkills.translation, languageSkills.conversation]"
          :fields="['name', 'read', 'write', 'translation', 'conversation']"
          :items="jobQualification.languages"
          :openEditModalMethod="openEditModal"
          @remove="removeLanguage"
      />

      <!-- Edit Language Modal -->
      <GeneralModal
          v-show="editedLanguage"
          title="ویرایش زبان"
          modal-id="languageModalId"
          @save="updateLanguage"
      >
        <div class="row mb-3">
          <div class="col-12 row m-0 p-0">
            <div class="col-md-6">
              <label class="form-label fw-bold">نام زبان</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="نام زبان را وارد کنید"
                  v-if="editedLanguage"
                  v-model="editedLanguage.name"
              />
            </div>
          </div>
          <div class="col-md-6" v-for="(skill, index) in languageSkills" :key="index">
            <label class="form-label fw-bold">{{ skill }}</label>
            <select class="form-select" v-if="editedLanguage" v-model="editedLanguage[index]">
              <option value="" disabled>تعیین سطح</option>
              <option :value="levelValue" v-for="(levelValue, levelIndex) in levels" :key="levelIndex">
                {{ levelValue }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseLanguage = {
  name: '',
  read: '',
  write: '',
  translation: '',
  conversation: '',
};
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  data() {
    return {
      newLanguage: structuredClone(baseLanguage),
      editedLanguage: null,
      editIndex: null,
      languageSkills: {read: "خواندن", write: "نوشتن", translation: "ترجمه", conversation: "مکالمه"},
      levels: ["مبتدی", "متوسط", "پیشرفته"],
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      }
    },
  },
  methods: {
    async addLanguage() {
      if (!this.newLanguage.name || !Object.entries(this.languageSkills).every(([index]) => !!this.newLanguage[index])) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newLanguage,
        endpoint: '/job-qualifications/store-language',
      })

      this.jobQualification.languages = [...this.jobQualification.languages, structuredClone(response.data)];
      this.newLanguage = structuredClone(baseLanguage);
    },
    removeLanguage(index) {
      const language = this.jobQualification.languages.find((_, i) => i === index);
      this.jobQualification.languages = this.jobQualification.languages.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: language.id,
        endpoint: '/job-qualifications/delete-language',
      })
    },
    openEditModal(language, index) {
      this.editedLanguage = structuredClone(language);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('languageModalId'));
      modal.show();
    },
    updateLanguage() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedLanguage.name || !Object.entries(this.languageSkills).every(([index]) => !!this.editedLanguage[index])) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.jobQualification.languages.splice(this.editIndex, 1, structuredClone(this.editedLanguage));

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedLanguage,
        endpoint: '/job-qualifications/update-language',
      })

      this.editIndex = null;
      this.editedLanguage = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('languageModalId'));
      modal.hide();
    }
  }
};
</script>
